import {
  ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO,
  OBTER_LABEL_FORMULARIOS_SUCCESS,
  OBTER_PERITOS_REQUEST,
  OBTER_PERITOS_SUCCESS,
  OBTER_REQUERIMENTOS_REQUEST,
  OBTER_REQUERIMENTOS_SUCCESS,
  OBTER_TODOS_FORMULARIOS_REQUEST,
  OBTER_TODOS_FORMULARIOS_SUCCESS,
  RESET_REQUERIMENTOS,
} from './constants';

export function obterPeritosRequest(values) {
  return {
    type: OBTER_PERITOS_REQUEST,
    values,
  };
}

export function obterPeritosSuccess(peritos) {
  return {
    type: OBTER_PERITOS_SUCCESS,
    peritos,
  };
}

export function obterStatusRequerimentosRequest({ status = '' }) {
  return {
    type: OBTER_REQUERIMENTOS_REQUEST,
    status,
  };
}

export function obterStatusRequerimentosSuccess({ status = '', data = [] }) {
  return {
    type: OBTER_REQUERIMENTOS_SUCCESS,
    status,
    data,
  };
}

export function obterFormulariosRequest() {
  return {
    type: OBTER_TODOS_FORMULARIOS_REQUEST,
  };
}

export function obterFormulariosSuccess(forms) {
  return {
    type: OBTER_TODOS_FORMULARIOS_SUCCESS,
    payload: forms,
  };
}

export function obterLabelFormulariosSuccess(forms) {
  return {
    type: OBTER_LABEL_FORMULARIOS_SUCCESS,
    payload: forms,
  };
}

export function atualizarDadosPessoaisRequerimentos(dados) {
  return {
    type: ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO,
    payload: dados,
  };
}

export function resetRequerimentos() {
  return {
    type: RESET_REQUERIMENTOS,
  };
}
